import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";

export default function SeasonSelector({
  seasons,
  setSelected,
  isLoading,
  selected,
}) {
  return (
    <Stack>
      <Form.Group controlId="select-season">
        <Form.Label>Season</Form.Label>
        <div className="flex-grow-1">
          <Form.Select
            name="select-season"
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
            disabled={isLoading}
          >
            <option disabled hidden value="">
              Select Season
            </option>
            {seasons &&
              seasons?.length > 0 &&
              seasons.map((season, index) => (
                <option key={index} value={season.id}>
                  {season.organization.name} - {season.name}
                </option>
              ))}
          </Form.Select>
        </div>
      </Form.Group>
    </Stack>
  );
}
